import { Modal, ConfigProvider, Radio, Space } from "antd";
import React, { useState } from "react";

export const ProfiauswahlModal = ({
  onConfirmOk,
  onCancel,
  visible,
  title,
  textArray,
  wahlCode,
}) => {
  const [value, setValue] = useState(
    parseInt(window.localStorage.getItem(`DruckWahl${wahlCode}`) || 0)
  );
  const onChange = (e) => {
    //console.log("radio checked", e.target.value);
    setValue(e.target.value);
  };
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#050",
          //colorBgContainer: "#88ff88",
        },
        components: {
          Modal: {
            titleColor: "#050",
          },
        },
      }}
    >
      <Modal
        title={title ? title : "Wählen Sie eine Druckvorlage"}
        open={visible}
        onOk={() => {
          if (wahlCode!==undefined)
            window.localStorage.setItem(`DruckWahl${wahlCode}`, value);
          onConfirmOk(value, textArray[value]);
        }}
        onCancel={onCancel}
      >
        <Radio.Group onChange={onChange} value={value}>
          <Space direction="vertical">
            {textArray.map((item, index) => (
              <Radio value={index} key={index}>
                {item}
              </Radio>
            ))}
          </Space>
        </Radio.Group>
      </Modal>
    </ConfigProvider>
  );
};
